// Controls
import { TooltipHost } from "../../../tooltip/TooltipHost";
import { CompleteTaskAnimationButton } from "../../completeTaskAnimationButton/CompleteTaskAnimationButton";
// Fluent UI
import { DirectionalHint } from "@fluentui/react";
import { areApprovalCompletionRequirementSet, areChecklistCompletionRequirementSet, areFormsCompletionRequirementSet } from "@ms/uno-models/lib/local/client/legacyPlanner/utilities/CompletionRequirementsUtils";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import taskInCompleteIcon from "@ms/uno-resources/lib/local/images/task-incomplete.svg";
// React
import React from "react";
// Styles
import { getCompleteTaskButtonWrapperItemClassNames } from "../../completeTaskAnimationButton/CompleteTaskButtonWrapper.styles";
/**
 * CompleteTaskButtonWrapper component is used to show the complete task button with a tooltip if there are any completion requirements.
 * @param props ICompleteTaskButtonWrapperProps props for the component
 */ export const CompleteTaskButtonWrapper = (props)=>{
    const { task, taskDetails, getFlights } = props;
    const isTaskCompleted = task.isComplete();
    const flights = getFlights();
    const enableMandatoryCheckListRequirements = areChecklistCompletionRequirementSet(task, taskDetails);
    const enableFormsRequirements = flights.EnableMandatoryForms && areFormsCompletionRequirementSet(task, taskDetails);
    const enableApprovalRequirements = flights.EnableMandatoryApprovals && areApprovalCompletionRequirementSet(task, taskDetails);
    const enableAppPoweredTaskCompletionRequirements = flights.EnableAppPoweredTasks && task.isAppPoweredTask() && !task.isComplete();
    const enableCompletionRequirements = enableMandatoryCheckListRequirements || enableFormsRequirements || enableApprovalRequirements || enableAppPoweredTaskCompletionRequirements;
    const classNames = getCompleteTaskButtonWrapperItemClassNames();
    const checkItem = enableCompletionRequirements ? /*#__PURE__*/ React.createElement(TooltipHost, {
        directionalHint: DirectionalHint.rightCenter,
        content: Strings.TaskEditor_ShowShouldCompleteRequirementsInfoLabel
    }, /*#__PURE__*/ React.createElement("img", {
        className: classNames.requiredCompleteIcon,
        tabIndex: -1,
        onClick: (evt)=>evt.stopPropagation(),
        src: taskInCompleteIcon,
        "data-is-focusable": props.isFocusZoneEnabled,
        "aria-label": Strings.TaskEditor_ShowShouldCompleteRequirementsInfoLabel,
        role: "checkbox",
        "aria-checked": isTaskCompleted
    })) : /*#__PURE__*/ React.createElement(CompleteTaskAnimationButton, {
        id: "completeButton" + task.id,
        isTaskCompleted: task.isComplete(),
        completeTaskButtonTabIndex: -1,
        ...props
    });
    return checkItem;
};
